define('viewModels/privileged/StatblockView',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'services/loggingService',
    'services/analyticsService',
    'services/intervalService',
    'viewModels/ViewModel',

    'util/codeUtils',

    'extensions/i18n/knockout.i18n'
], function (
    ko,
    _,
    moment,
    log,
    analyticsService,
    intervalService,
    ViewModel,
    codeUtils
) {
    'use strict';

    // ===================================================================================
    // Private Variables
    // ===================================================================================

    //
    // Constants
    //
    var CURRENT_INTERVAL_KEY = "current";
    var DAY_INTERVAL_KEY = "day";

    // ===================================================================================
    // Class Definition
    // ===================================================================================

    var StatblockView = ViewModel.extend(function (metricDataCollection) {
        var self = this;

        // ===============================================================================
        // Private Variables
        // ===============================================================================

        // Configure selectable intervals
        var intervals = {};
        var selectedIntervalKey = ko.observable(CURRENT_INTERVAL_KEY);

        self.key = CURRENT_INTERVAL_KEY;

        // Current Day Interval
        intervals[DAY_INTERVAL_KEY] = {
            dateMessage: self.computed(function () {
                var dayMoment = moment(intervalService.currentInterval().split("/")[0]).startOf("day");
                return ko.i18n.formatDate(dayMoment.toDate(), "dddd, LL");
            }),
            interval: intervalService.currentDayInterval,
            intervals: ko.observable({
                day: intervalService.dayIntervalBeforeCurrentIntervalStart,
                interval: intervalService.currentInterval
            }),
            messageKey: 'statblock.intervals.day'
        };

        // Current Period interval
        intervals[CURRENT_INTERVAL_KEY] = {
            dateMessage: self.computed(function () {
                var startDate = moment(intervalService.currentInterval().split("/")[0]).toDate();
                var endDate = moment(intervalService.currentInterval().split("/")[1]).toDate();

                return ko.i18n.renderString("statblock.intervals.intervalDate", {
                    startTime: ko.i18n.formatDate(startDate, "LT"),
                    endTime: ko.i18n.formatDate(endDate, "LT")
                });
            }),
            interval: intervalService.currentInterval,
            intervals: ko.observable({
                interval: intervalService.currentInterval
            }),
            messageKey: 'statblock.intervals.interval'
        };

        // ===============================================================================
        // Modifiable Attributes
        // ===============================================================================

        // Declare the template to use for the avatar area instead of the default template
        self.avatarTemplate = ko.observable();

        // The source URI for the image to display for the avatar of the statblock
        self.avatarImgSrc = ko.observable();

        // The fallback font icon to display if the image declared in avatarImgSrc fails
        // to load.
        self.avatarIcon = ko.observable();

        self.chartTemplate = ko.observable();

        //
        // Template Data
        //

        self.avatarImgError = ko.observable(false);

        self.isLoading = ko.observable(false);
        self.isSelectingInterval = ko.observable(false);

        // The collection of data to display
        self.metricData = metricDataCollection;

        // Get the ISO 8601 string for the selected interval
        //
        // @return {String}
        self.selectedInterval = self.computed(function () {
            return intervals[selectedIntervalKey()].interval();
        });

        self.selectedAlternativeInterval = self.computed(function () {
            return intervals[selectedIntervalKey()].intervals();
        });

        self.selectedIntervalDateMessage = self.computed(function () {
            return intervals[selectedIntervalKey()].dateMessage();
        });

        // Get the message key for the selected interval
        //
        // @return {String} a string representing the externalized string for the selected
        //                  interval.
        self.selectedIntervalMessageKey = self.computed(function () {
            return intervals[selectedIntervalKey()].messageKey;
        });

        // Helper method to determine if the template should try to load the image for an
        // avater.
        self.shouldDisplayAvatarIcon = self.computed(function () {
            log.debug("self.avatarImgSrc() is currently set to: '" + self.avatarImgSrc() + "' on the object: " + self);
            log.debug("self.avatarImgError() is currently set to: '" + self.avatarImgError() + "' on the object: " + self);

            // By utilizing this method, we only bother trying to load an image if an
            // avatar image URI has been provided.
            return _.isUndefined(self.avatarImgSrc()) || self.avatarImgError();
        });

        // Generate CSS classes from statblock metrics
        //
        // @return {String} a string to be used as a CSS class
        //
        self.generateMetricCSSClass = _.partial(codeUtils.generateClassFromString,"statblock-metric-");

        // ===============================================================================
        // Events
        // ===============================================================================

        self.selectCurrentInterval = function () {
            self.key = CURRENT_INTERVAL_KEY;
            selectedIntervalKey(CURRENT_INTERVAL_KEY);
            self.isSelectingInterval(false);
        };

        self.selectDayInterval = function () {
            self.key = DAY_INTERVAL_KEY;
            selectedIntervalKey(DAY_INTERVAL_KEY);
            self.isSelectingInterval(false);
        };
    });

    return StatblockView;
});

